var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('NavBar',{attrs:{"currentNav":_vm.currentNav},on:{"select":_vm.handleSelect}}),_c('HomeTrain',{attrs:{"trainTypeList":_vm.trainTypeList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }